import styles from "./WOSummary.module.css";
import { Table } from "rsuite";
const { Column, HeaderCell, Cell } = Table;

function WOSummary({ title, monthStats, month }) {
  return (
    <>
      <div className={styles.table_container}>
        <div className={styles.table_title}>{title}</div>

        <Table loading={false} autoHeight data={monthStats}>
          <Column width={210} align="left" fixed>
            <HeaderCell>Name</HeaderCell>
            <Cell dataKey="name" />
          </Column>

          <Column width={170}>
            <HeaderCell>Responsible</HeaderCell>
            <Cell dataKey="responsible" />
          </Column>

          <Column width={110}>
            <HeaderCell>Planned</HeaderCell>
            <Cell dataKey="planned" />
          </Column>

          <Column width={110}>
            <HeaderCell>Postponed</HeaderCell>
            <Cell dataKey="postponed" />
          </Column>

          <Column width={110}>
            <HeaderCell>Filled</HeaderCell>
            <Cell dataKey="filled" />
          </Column>

          <Column width={110}>
            <HeaderCell>Performed</HeaderCell>
            <Cell dataKey="performed" />
          </Column>

          <Column width={110}>
            <HeaderCell>Total</HeaderCell>
            <Cell dataKey="total" />
          </Column>

          <Column width={120}>
            <HeaderCell
              title={
                month === "current" ? "for the last 12 month" : "Last month"
              }
            >
              {month === "current" ? "Overdue (12m)" : "Overdue"}
            </HeaderCell>
            <Cell
              dataKey="overDue"
              className={styles.overdue_cell}
              title={
                month === "current" ? "for the last 12 month" : "Last month"
              }
            />
          </Column>
        </Table>
      </div>
    </>
  );
}

export default WOSummary;
